import { DropDown } from "../../../../../common/domain/models/dropdown";
import { IGetIndiceReajusteDropDownUseCase } from "../../../presentation/useCases/read/get_indice_reajuste_drop_down_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetIndiceReajusteDropDownUseCase
 */

export class GetIndiceReajusteDropDownUseCase implements IGetIndiceReajusteDropDownUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async getIndiceReajusteDropDown(): Promise<DropDown[]> {
    return this.repository.getIndiceReajusteDropDown();

  }
}
